import { render } from "./Disclaimer.vue?vue&type=template&id=06a0d38d&scoped=true"
import script from "./Disclaimer.vue?vue&type=script&lang=js"
export * from "./Disclaimer.vue?vue&type=script&lang=js"

import "./Disclaimer.vue?vue&type=style&index=0&id=06a0d38d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a0d38d"]])

export default __exports__